module.exports = __webpack_public_path__ + "img/logoRW.fb90aa56.png";